import { action, computed, observable, makeObservable } from 'mobx';
import { EventIndexView } from '../../../../types/events';
import { EventId } from '../../../../../commonv3/types/events';
import { EventWaitlistId } from '../../../../../commonv3/types/eventWaitlists';
import { EventWaitlistApis } from '../../../../apis/event_waitlists';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EventWaitlistIndexView } from '../../../../types/eventWaitlists';
import { EventStatusUtils } from './../utils/EventStatusUtils';
import moment from 'moment-timezone';
import { EventDetails } from '../../../../../mainv2/types/event';

export class EventWaitlistState {
  eventWaitlists: RemoteResourceV3<EventWaitlistIndexView[]> = RemoteResourceV3.loading();
  submitting = false;
  success = false;

  constructor() {
    makeObservable(this, {
      eventWaitlists: observable,
      submitting: observable,
      success: observable,
      init: action.bound,
      loading: computed,
      reloadEventWaitlists: action.bound,
      canShowWaitlist: action.bound,
      createEventWaitingList: action.bound,
      cancelEventWaitingList: action.bound,
    });
  }

  async init() {
    await this.reloadEventWaitlists();
  }

  get loading() {
    return this.eventWaitlists.loading;
  }

  async reloadEventWaitlists() {
    await updateRemoteResourceV3(
      this.eventWaitlists,
      (v) => (this.eventWaitlists = v),
      () => EventWaitlistApis.findAll()
    );
  }

  overDeadlineCreateWaitlist(entry: EventIndexView | EventDetails) {
    return moment(entry.starts_at).hour(8).minute(0).second(0).isBefore(moment());
  }

  canShowWaitlist(entry: EventIndexView | EventDetails, reserved: boolean) {
    return EventStatusUtils.isEventFull(entry) && !reserved && !this.overDeadlineCreateWaitlist(entry);
  }

  async createEventWaitingList(eventId: EventId) {
    try {
      this.success = false;
      this.submitting = true;
      const eventWaitlist = await EventWaitlistApis.create(eventId);
      this.success = true;
      setTimeout(async () => {
        this.eventWaitlists = RemoteResourceV3.of([eventWaitlist]);
        this.success = false;
      }, 1000);
    } finally {
      this.submitting = false;
    }
  }

  async cancelEventWaitingList(eventWaitlistId: EventWaitlistId) {
    try {
      this.success = false;
      this.submitting = true;
      await EventWaitlistApis.cancel(eventWaitlistId);
      this.success = true;
      setTimeout(() => {
        this.eventWaitlists = RemoteResourceV3.of([]);
        this.success = false;
      }, 1000);
    } finally {
      this.submitting = false;
    }
  }
}
